export class MessageBoxViewRestrictionLg {
	textAreaWidth = '350px';
	btnWidth = '104px';
	btnHeight = '34px';
	fontSize = '12px';
}
